<template>
    <div class="employee-documents">
        <div v-for="doc in documents" class="uk-grid uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right employee-documents-row">
            <a :href="doc.url" target="_blank" class="uk-width-1-2@l uk-width-3-4 uk-padding-remove" >{{ doc.name }}</a>
            <div class="uk-width-1-4@l uk-width-1-6 controls">
                <a href="#" :uk-toggle="'target: #' + deleteModalId" @click="activateDeleteModal(doc.id)"><i class="fas fa-trash"></i></a>
            </div>

        </div>
        <div uk-form-custom class="uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right">
            <input type="file" multiple @change="uploadFile($event)" />
            <span class="uk-link">
                <i class="fas fa-plus-circle"></i> Add Another Document
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RequisitionDocuments",

        props:{
            rid:Number,
            deleteModalId:String,
            deleteFormRef:String,
        },

        data(){
            return {
                documents:[]
            };
        },

        mounted(){
            this.loadFiles();
        },

        methods:{
            loadFiles(){
                axios.get("/api/requisition/files/"+this.rid)
                    .then((pack) => this.updateList(pack));
            },
            updateList(pack){
                this.documents = pack.data.data;
            },
            startSearch(){
                this.loadFiles();
            },
            uploadFile(event){
                let formData = new FormData();

                for(let i = 0; i < event.target.files.length;++i){
                    formData.append("file" + i, event.target.files[i]);
                }

                axios.post("/api/requisition/upload/"+this.rid, formData)
                    .then(() => this.loadFiles());
            },
            activateDeleteModal(id){
                this.$root.$refs[this.deleteFormRef].loadForm(id);
            },
        }
    }
</script>
